module.exports = __webpack_public_path__ + "static/media/color-variant.065b8e4a.png";